exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/deep/ .dx-command-edit .dx-link {\n  text-decoration: none;\n  text-align: center;\n  font-size: 18px;\n  margin: 0 3px; }\n\n/*/deep/.dx-item .dx-toolbar-item .dx-toolbar-button{\n  margin: 5px;\n}*/\n/deep/ .dx-datagrid-search-panel.dx-texteditor {\n  margin: 5px; }\n\n/deep/ .dx-datagrid-table .dx-row > td {\n  font-size: 14px;\n  margin: 0 3px; }\n\n/deep/ #gridContainer {\n  height: 440px; }\n\n/deep/ .dx-datagrid-headers .dx-datagrid-table .dx-row > td {\n  font-size: 18px;\n  margin: 0 3px; }\n\n/deep/ .dx-command-edit .dx-link:hover {\n  opacity: 0.8; }\n\n/deep/ #select-position {\n  display: inline-block;\n  vertical-align: middle; }\n\n/deep/ .select-position span {\n  vertical-align: middle;\n  margin-right: 10px; }\n\n#Prolongation {\n  height: auto !important; }\n\n.filiation-id-chooser {\n  max-width: 100%;\n  margin-top: 2%;\n  background-color: #FFF;\n  padding: 15px;\n  text-align: center; }\n  .filiation-id-chooser button {\n    width: 100%; }\n  .filiation-id-chooser md-select {\n    width: 80%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/src/app/prolongation/prolongation.component.scss
// module id = ../../../../../src/app/prolongation/prolongation.component.scss
// module chunks = 0